{
  "adaptation.title": "Plan uyarlama",
  "adaptation.lede": "Neyin değiştiğini kaydedin, tekrar eden sürtünmeyi inceleyin ve gerekçe ile ödünleşimi kaybetmeden işleri bilinçli biçimde taşıyın.",
  "adaptation.error.generic": "Planlama değişikliği tamamlanamadı.",
  "adaptation.filter.from": "Başlangıç",
  "adaptation.filter.to": "Bitiş",
  "adaptation.report.title": "Sürtünme özeti",
  "adaptation.report.description": "Seçilen döneme ait olgusal sayımlar; puan, tanı veya yargı içermez.",
  "adaptation.report.total": "Kaydedilen sapmalar",
  "adaptation.report.unresolved": "Karar bekleyenler",
  "adaptation.report.causes": "En sık kaydedilen koşullar",
  "adaptation.report.repeats": "Tekrar eden konular",
  "adaptation.report.empty": "Bu dönemde yeterli kayıt yok.",
  "adaptation.dayRevision.title": "Değişen günü kabul et",
  "adaptation.dayRevision.description": "Kullanılabilir zaman azaldığında ancak tek tek bloklara dokunulmaması gerektiğinde, açığı incelenmiş tek bir gün revizyonu olarak kaydedin.",
  "adaptation.dayRevision.deficit": "Artık kullanılamayan dakika",
  "adaptation.dayRevision.preview": "Revizyonu önizle",
  "adaptation.dayRevision.apply": "Revizyonu uygula",
  "adaptation.dayRevision.confirmTitle": "Bu gün revizyonu uygulansın mı?",
  "adaptation.dayRevision.confirmDescription": "{{minutes}} dakikalık kapasite kaybını kaydedip belirttiğiniz gerekçeyi yeniden planlama geçmişinde korur.",
  "adaptation.dayRevision.previewResult": "Önizleme tamamlandı: {{minutes}} dakika kabul edilecek. Hiçbir kayıt değişmedi.",
  "adaptation.dayRevision.appliedResult": "Gün revize edildi: {{minutes}} dakika kabul edildi ve karar kaydedildi.",
  "adaptation.deviations.title": "Plan sapmaları",
  "adaptation.deviations.description": "Planla gerçekleşen arasındaki farkı kaydedin, ardından ne yapılacağına karar verin.",
  "adaptation.deviations.emptyTitle": "Kaydedilmiş sapma yok",
  "adaptation.deviations.emptyDescription": "Bu tarih aralığında çözülecek bir kayıt bulunmuyor.",
  "adaptation.sessions.title": "Yeniden planlama oturumları",
  "adaptation.sessions.description": "Durumu, düşünülen değişiklikleri, ödünleşimleri ve nihai kararı bir arada tutun.",
  "adaptation.replan.title": "Bağlamıyla birlikte taşı",
  "adaptation.replan.description": "Aday günleri tarih sırasıyla inceleyin. Exognitos kapasiteyi ve korumaları gösterir; ödünleşimi siz seçersiniz.",
  "adaptation.replan.slot": "{{free}} dk boş · {{committed}} dk ayrılmış",
  "adaptation.replan.protected": "Korunan zaman",
  "adaptation.replan.fits": "Boş zamana sığıyor",
  "adaptation.replan.doesNotFit": "Boş zamanı aşıyor",
  "adaptation.edit.title": "Bu kaydı düzelt",
  "adaptation.resolve.title": "Kararınızı kaydedin",
  "adaptation.adjustment.title": "Düşünülen bir ayarlama ekle",
  "adaptation.close.title": "Bu yeniden planlama oturumunu kapat",
  "adaptation.session.open": "Açık",
  "adaptation.session.closed": "Kapalı",
  "adaptation.session.adjustmentCount": "Kaydedilen ayarlama: {{count}}",
  "adaptation.deleteDeviation.title": "Bu sapma kalıcı olarak silinsin mi?",
  "adaptation.deleteDeviation.description": "Geçmiş kaydı kaldırılır ve işlem geri alınamaz.",
  "adaptation.deleteSession.title": "Bu yeniden planlama oturumu kalıcı olarak silinsin mi?",
  "adaptation.deleteSession.description": "Oturum ve ayarlama geçmişi kaldırılır; geri getirilemez.",
  "adaptation.action.record": "Sapmayı kaydet",
  "adaptation.action.review": "İncele ve çöz",
  "adaptation.action.save": "Düzeltmeyi kaydet",
  "adaptation.action.resolve": "Kararı kaydet",
  "adaptation.action.delete": "Kalıcı sil",
  "adaptation.action.showOptions": "Günleri göster",
  "adaptation.action.applyMove": "Bu güne taşı",
  "adaptation.action.startSession": "Oturumu başlat",
  "adaptation.action.open": "Oturumu aç",
  "adaptation.action.addAdjustment": "Ayarlama ekle",
  "adaptation.action.closeSession": "Oturumu kapat",
  "adaptation.field.day": "Gün",
  "adaptation.field.task": "Görev",
  "adaptation.field.noTask": "Bağlı görev yok",
  "adaptation.field.chooseTask": "Açık bir görev seçin",
  "adaptation.field.kind": "Ne değişti",
  "adaptation.field.cause": "Koşul",
  "adaptation.field.note": "Ne oldu",
  "adaptation.field.actualMinutes": "Gerçekleşen dakika",
  "adaptation.field.resolution": "Karar",
  "adaptation.field.resolutionNote": "Karar notu",
  "adaptation.field.horizon": "İncelenecek gün",
  "adaptation.field.reason": "Bu değişikliğin gerekçesi",
  "adaptation.field.tradedAway": "Bu değişikliğin yerinden ettiği veya vazgeçirdiği şey",
  "adaptation.field.overrideProtection": "Korunan zamanı geçersiz kıl",
  "adaptation.field.overrideProtectionHint": "Yalnızca korunan zaman çakışmasını bilinçli olarak kabul ediyorsanız kullanın.",
  "adaptation.field.trigger": "Neden yeniden planlıyorsunuz",
  "adaptation.field.situation": "Mevcut durum",
  "adaptation.field.adjustmentKind": "Ayarlama türü",
  "adaptation.field.subjectLabel": "Ele alınan konu",
  "adaptation.field.verdict": "Nihai karar",
  "adaptation.kind.never_started": "Hiç başlanmadı",
  "adaptation.kind.started_not_finished": "Başlandı, tamamlanmadı",
  "adaptation.kind.overran": "Planlanandan uzun sürdü",
  "adaptation.kind.underran": "Planlanandan kısa sürdü",
  "adaptation.kind.displaced": "Zamanı başka bir şey aldı",
  "adaptation.kind.moved_early": "Gün gelmeden taşındı",
  "adaptation.kind.done_elsewhere": "Planlanan zaman dışında yapıldı",
  "adaptation.kind.deliberately_skipped": "Bilinçli olarak atlandı",
  "adaptation.cause.not_recorded": "Kaydedilmedi",
  "adaptation.cause.energy": "Enerji yeterli değildi",
  "adaptation.cause.sleep": "Uyku",
  "adaptation.cause.health": "Sağlık",
  "adaptation.cause.mood": "Duygusal durum",
  "adaptation.cause.motivation": "İstek oluşmadı",
  "adaptation.cause.competing_work": "Zamanı başka iş aldı",
  "adaptation.cause.external_demand": "Başka birinin ihtiyacı zamanı aldı",
  "adaptation.cause.social_pull": "Plan yerine insanlara zaman ayrıldı",
  "adaptation.cause.interruption": "Kesinti",
  "adaptation.cause.wrong_environment": "Uygun olmayan ortam",
  "adaptation.cause.missing_input": "Bir bağımlılık hazır değildi",
  "adaptation.cause.unclear_next_step": "Sonraki adım belirsizdi",
  "adaptation.cause.underestimated": "İşin kapsamı düşük tahmin edildi",
  "adaptation.cause.overpacked_day": "Gün aşırı doluydu",
  "adaptation.cause.impulse": "Anlık bir dürtü izlendi",
  "adaptation.cause.lost_track_of_time": "Zamanın takibi kaybedildi",
  "adaptation.cause.travel": "Seyahat veya uzakta olma",
  "adaptation.cause.changed_mind": "Fikir değişti",
  "adaptation.resolution.pending": "Henüz karar verilmedi",
  "adaptation.resolution.rescheduled": "Yeniden planlandı",
  "adaptation.resolution.rescoped": "Küçültülüp korundu",
  "adaptation.resolution.delegated_to_minimum": "Asgari sürüme indirildi",
  "adaptation.resolution.dropped": "Bırakıldı",
  "adaptation.resolution.absorbed": "Olduğu yerde bırakıldı",
  "adaptation.resolution.escalated": "Daha geniş planlama gerekiyor",
  "adaptation.trigger.day_collapsed": "Gün önemli ölçüde değişti",
  "adaptation.trigger.day_close": "Günü kapatma",
  "adaptation.trigger.capacity_changed": "Kullanılabilir zaman değişti",
  "adaptation.trigger.new_commitment": "Yeni bir taahhüt geldi",
  "adaptation.trigger.period_slipped": "Bir dönem kaydı",
  "adaptation.trigger.routine_review": "Rutin inceleme",
  "adaptation.trigger.periodic": "Düzenli yeniden planlama",
  "adaptation.trigger.assistant": "Asistanla başlatıldı",
  "adaptation.adjustment.nothing": "Değerlendirildi ve değiştirilmedi",
  "adaptation.adjustment.block_moved": "Takvim bloğu taşındı",
  "adaptation.adjustment.block_removed": "Takvim bloğu kaldırıldı",
  "adaptation.adjustment.block_created": "Takvim bloğu oluşturuldu",
  "adaptation.adjustment.task_deferred": "Görev ertelendi",
  "adaptation.adjustment.task_estimate_changed": "Görev tahmini değişti",
  "adaptation.adjustment.task_canceled": "Görev iptal edildi",
  "adaptation.adjustment.task_skipped": "Rutin oluşumu atlandı",
  "adaptation.adjustment.task_priority_changed": "Görev önceliği değişti",
  "adaptation.adjustment.routine_paused": "Rutin duraklatıldı",
  "adaptation.adjustment.period_moved": "Dönem taşındı",
  "adaptation.adjustment.period_extended": "Dönem uzatıldı",
  "adaptation.adjustment.period_status_changed": "Dönem durumu değişti",
  "adaptation.adjustment.checkpoint_moved": "Kontrol noktası taşındı"
}
